export const zh_tw = {
    Global: {
      save: '存檔',
      savingInProgress: 'Saving in progress ZHTW',
      edit: '編輯',
      amend: 'Amend ZHTW',
      editProposal: 'Edit proposal ZHTW',
      delete: '刪除',
      cancel: '取消',
      confirm: '確認',
      proceed: '繼續',
      assign: '阿辛',
      submit: '提交',
      accepted: '公認',
      denied: '被拒絕',
      deny: '拒絕',
      done: '完成了',
      notDone: '尚未完成',
      started: '已開始',
      notRelevant: '沒有關聯',
      noInfo: '暫無信息',
      addComment: '添加評論',
      noComments: '沒意見',
      comment: '評論',
      start: '開始',
      end: '結束',
      pending: '待定',
      approve: '批准',
      approved: '已批准',
      notApproved: '尚未批准',
      release: '釋放',
      released: '已發行',
      notReleased: '未發布',
      reopen: '重新開啟',
      requestedBy: '被要求',
      requestedAt: '要求在',
      proposedDecision: '建議的決定',
      proposedCategory: '建議類別',
      proposedSubcategory: 'Proposed subcategory',
      search: '搜索',
      noResults: '沒有結果',
      upload: '上載',
      uploading: '上載中',
      noFilesUploaded: '沒有上傳文件',
      close: '關',
      back: '背部',
      next: '下一個',
      unknown: '未知',
      from: '從',
      to: '至',
      logout: '登出',
      profile: '輪廓',
      group: '組',
      code: '碼',
      confirmationDialogTitle: '需要確認',
      confirmDeleteFileDialogContent: '您確定要刪除此文件',
      report: '報告',
      unsavedAnswers: '您尚未保存答案。 確認您將丟失所有未保存的數據',
      unsavedAnswersActionMode: '您尚未保存答案。 您要保存嗎？',
      noOptions: '沒有選擇',
      actionMode: '動作模式',
      reason: '原因',
      optional: '可選的',
      choose: '選擇',
      serialNumberMissing: 'Serial number missing ZHTW',
      recipientEmails: 'Recipient Emails (one address per line) ZHTW',
      DatePicker: {
        cancelLabel: '取消',
        okLabel: '好',
        minDateMessage: '日期不能早於最短日期',
        maxDateMessage: '日期不能晚於最大日期',
        invalidDateMessage: '無效的日期格式',
      },
      Errors: {
        authErrorTitle: '授權錯誤',
        authErrorParagraph1: '您無權訪問此應用',
        authErrorParagraph2: '請與您的管理員聯繫',
        authErrorParagraph3: '或從Active Directory註銷，然後重試',
        pageNotFound: '網頁未找到',
        pageNotFoundParagraph1: '我們找不到此頁面',
        back: '家',
        rotateDevice: '請旋轉您的設備',
      },
      Feedback: {
        error: '出問題了...操作失敗',
        authentication: '正在驗證...請稍候',
        success: '動作成功完成',
        limitReached: '達到商業決策限制',
        requestHasBeenSentToApprover: '請求已發送給審批者',
        noQuestions: '沒有選擇產品系列的問題',
        decisionNotSend: '決策未成功發送到SAP。',
        noLimitForCC: '您沒有為此客戶中心設置商業限制',
        jobCostDoesNotExist:'SAP作業中的作業成本在PARS數據庫中不存在。',
        materialNumberBrandDoesNotExist: '物料編號品牌不存在。',
        jobIsLocked: '作業被鎖定。',
        noPicturesAreUploaded: '沒有照片上傳',
        rateIsProvided: '评价已成功登记',
        rateHasToBeDifferent: '判定评价必须与之前的不同',
      },
      Status: {
        title: '狀態',
        awaitingEquipment: '等待設備',
        equipmentReceivedWithDocumentation: '隨附文件的設備',
        jobReleased: '職位發布',
        productEvaluation: '產品評估',
        strippedAndDecontaminated: '剝離並消毒',
        builtAndTested: '建立並測試',
        shipped: '已出貨',
        technicalAndCommercialDecision: '技術和商業決策',
        finalReportReleased: '最終報告發布',
        closed: '關閉',
        productInvestigation: '產品調查',
        customerHold: '客戶保留',
        notStarted: '沒有開始',
      },
      Roles: {
        RECEIVING: '接收',
        SERVICE_ENGINEER: '維修工程師',
        FAILURE_ANALYSIS_ENGINEER: '故障分析工程師',
        SENIOR_FAILURE_ANALYSIS_ENGINEER: '高級故障分析工程師',
        FAILURE_ANALYSIS_MANAGER: '失敗分析經理',
        SERVICE_TECHNOLOGY_CENTER_MANAGER: '服務技術中心經理',
        QUALITY_MANAGER: '質量經理',
        SERVICE_TECHNICAL_SUPPORT_TEAM: '服務技術支持團隊',
        PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM: '產品公司技術支持團隊',
        DIVISION_OR_BUSINESS_AREA: '部門或業務領域',
        CUSTOMER_CENTER: '客戶中心',
        CUSTOMER: '顧客',
        CUSTOMER_CENTER_SERVICE_ENGINEER: '客戶中心服務工程師',
        SENIOR_CUSTOMER_CENTER_SERVICE_ENGINEER: 'Senior customer center service engineer ZHTW',
        SUPERADMIN: '超級管理員',
        ZONE_LEADER: '區長',
        QUESTION_ADMIN: '問題管理員',
        DISTRIBUTOR: '發行人',
      },
      Permissions: {
        VIEW_JOB: '查看工作',
        EDIT_JOB: '編輯工作',
        IMPORT_JOB_FROM_SAP: '從SAP導入作業',
        LEVEL_3_RELEASE_FOR_INVESTIGATION: '3級發布以供調查',
        LEVEL_4_RELEASE_FOR_INVESTIGATION: '4級發布以進行調查',
        GENERATE_AND_DOWNLOAD_REPORT: '生成並下載報告',
        VIEW_LOG: '查看日誌',
        VIEW_CONVERSATION: '查看對話',
        PARTICIPATE_IN_CONVERSATION: '參加對話',
        TAG_INTEREST: '標籤興趣',
        ADD_REMOVE_FROM_TEAM: '從團隊中添加和刪除',
        CREATE_JOB: '建立工作',
        DELETE_JOB: '刪除工作',
        REQUEST_DIFFERENT_REPORT_LEVEL: '請求不同的報告級別',
        APPROVE_DIFFERENT_REPORT_LEVEL: '批准不同的報告級別',
        WARRANTY_DECISION: '保修決定',
        GOODWILL_DECISION: '商譽決定',
        LEVEL_1_REPORT_APPROVAL: '1級報告批准',
        LEVEL_2_REPORT_APPROVAL: '2級報告批准',
        LEVEL_3_REPORT_APPROVAL: '3級報告批准',
        LEVEL_4_REPORT_APPROVAL: '4級報告批准',
        LEVEL_1_REPORT_REOPEN: 'Level 1 report reopen ZHTW',
        LEVEL_2_REPORT_REOPEN: 'Level 2 report reopen ZHTW',
        LEVEL_3_REPORT_REOPEN: 'Level 3 report reopen ZHTW',
        LEVEL_4_REPORT_REOPEN: 'Level 4 report reopen ZHTW',
        REOPEN_REPORT: '重新打開報告',
        REQUEST_FAILED_PARTS: '索取失效零件',
        SHIP_FAILED_PARTS: '運送故障零件',
        PRINT_INPUT_SHEETS: '打印輸入紙',
        ADMINISTRATE_QUESTIONS: '管理問題',
        ADMINISTRATE_DATA: '管理數據',
        DOWNLOAD_PICTURES: 'Download pictures ZHTW',
        REQUEST_TECHNICAL_WARRANTY_DECISION: 'Request technical warranty decission ZHTW',
        AMEND_APPROVED_TECHNICAL_DECISION: 'Amend approved technical decision ZHTW',
        AMEND_APPROVED_COMMERCIAL_DECISION: 'Amend approved commercial decision ZHTW',
        ADD_INITIAL_WARRANTY_CODE: 'Add initial warranty code ZHTW',
        RECLASSIFY_TECHNICAL_WARRANTY_CATEGORY: 'Reclassify technical warranty category ZHTW',
        APPROVE_REPORT_LEVEL_4_DOWNGRADE: 'Approve report level 4 downgrade ZHTW',
      },
      Alerts: {
        noAlerts: '沒有警報',
        healthAndSafetyInformationMissing: '健康和安全信息丟失',
        jobNotReleased: '作業未發布',
        noRecentStatusChange: '最近狀態未更改',
        noServiceTechnicalSupportInvolvement: '不涉及服務技術支持',
        noProductCompanyTechnicalSupportInvolvement: '沒有產品公司的技術支持參與',
        noTechnicalWarrantyDecision: '沒有技術保修決定',
        noCommercialDecision: '沒有商業決定',
        reportNotApproved: '報告未獲批准',
      },
      Actions: {
        ADD_JOB: '新增工作',
        IMPORT_JOB: '從SAP導入的作業',
        DELETE_JOB: '刪除的工作',
        VERIFY_JOB: '經過驗證的工作',
        SET_PRICE: '編輯的職位-價格',
        ADD_TEAM_MEMBER: '團隊成員已添加',
        REMOVE_TEAM_MEMBER: '團隊成員已刪除',
        REQUEST_REPORT_LEVEL_CHANGE: '請求的報告級別更改',
        APPROVE_REPORT_LEVEL_CHANGE: '批准的報告級別更改',
        DENY_REPORT_LEVEL_CHANGE: '拒絕的報告級別更改',
        REQUEST_REPORT_APPROVAL: '要求報告批准',
        APPROVE_REPORT_APPROVAL: '批准的報告批准',
        DENY_REPORT_APPROVAL: '拒絕批准報告',
        SET_WARRANTY_START_DATE: '編輯過的工作-保修開始日期',
        SET_WARRANTY_END_DATE: '編輯過的工作-保修截止日期',
        EQUIPMENT_SERIAL_NUMBER_EDITED: '編輯的作業-設備序列號',
        MATERIAL_NUMBER_EDITED: '編輯的作業-物料編號',
        WORKED_ON_JOB: '編輯的工作-更新表格',
        UPLOADED_FILE_ON_JOB: '編輯的作業-上傳文件',
        REQUEST_TECHNICAL_WARRANTY_DECISION: '要求的技術保修決定',
        APPROVE_TECHNICAL_WARRANTY_DECISION: '批准的技術保修決定',
        DENY_TECHNICAL_WARRANTY_DECISION: '拒絕的技術保修決定',
        REQUEST_COMMERCIAL_WARRANTY_DECISION: 'Requested commercial warranty decision',
        APPROVE_COMMERCIAL_WARRANTY_DECISION: '批准的商業保修決定',
        NULLIFY_COMMERCIAL_WARRANTY_DECISION: '無效的商業保修決定',
        DENY_COMMERCIAL_WARRANTY_DECISION: '被拒絕的商業保修決定',
        SEND_COMMENT: '已添加評論',
        REOPEN_REPORT: '編輯過的工作-重新打開報告',
        AWAITING_EQUIPMENT_STATUS_SET: '編輯狀態-等待裝備',
        AWAITING_EQUIPMENT_STATUS_RESET: '編輯狀態-等待設備重置',
        EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_SET: '編輯狀態-收錄了帶有文檔集的設備',
        EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_RESET: '編輯狀態-收到設備並重置文檔',
        JOB_RELEASED_STATUS_SET: '編輯狀態-作業已發布集',
        JOB_RELEASED_STATUS_RESET: '編輯狀態-作業釋放重置',
        PRODUCT_EVALUATION_STATUS_SET: '編輯狀態-產品評估集',
        PRODUCT_EVALUATION_STATUS_RESET: '編輯狀態-產品評估重置',
        PRODUCT_INVESTIGATION_STATUS_SET: '編輯狀態-產品調查集',
        PRODUCT_INVESTIGATION_STATUS_RESET: '編輯狀態-產品調查重設',
        STRIPPED_AND_DECONTAMINATED_STATUS_SET: '編輯狀態-剝離和去污的佈景',
        STRIPPED_AND_DECONTAMINATED_STATUS_RESET: '編輯狀態-剝離和淨化後的重置',
        BUILT_AND_TESTED_STATUS_SET: '編輯狀態-構建和測試集',
        BUILT_AND_TESTED_STATUS_RESET: '編輯狀態-構建並測試重置',
        SHIPPED_STATUS_SET: '編輯狀態-已發貨',
        SHIPPED_STATUS_RESET: '編輯狀態-出廠重置',
        TECHNICAL_AND_COMERCIAL_DECISION_STATUS_SET: '編輯狀態-技術和商業決策集',
        TECHNICAL_AND_COMERCIAL_DECISION_STATUS_RESET: '編輯狀態-重置技術和商業決策',
        FINAL_REPORT_RELEASED_STATUS_SET: '編輯狀態-已發布最終報告集',
        FINAL_REPORT_RELEASED_STATUS_RESET: '編輯狀態-最終報告已發布重置',
        CLOSED_STATUS_SET: '編輯狀態-重置關閉',
        CLOSED_STATUS_RESET: '編輯狀態-重置關閉',
        CUSTOMER_HOLD_STATUS_SET: '編輯狀態-客戶保留集',
        CUSTOMER_HOLD_STATUS_RESET: '編輯狀態-客戶保留重置',
        REFACTOR_TECHNICAL_WARRANTY_DECISION: '編輯的技術決策類別',
        GENERATE_ALERT: '產生警報',
        INITIAL_WARRANTY_CODE_EDITED: '初始保修代碼已更改',
        AMEND_APPROVED_TECHNICAL_DECISION: 'Amended approved technical warranty decision ZHTW',
        AMEND_APPROVED_COMMERCIAL_DECISION: 'Amended approved commercial decision ZHTW',
        DELETE_APPROVED_TECHNICAL_DECISION: 'Deleted aproved technical warranty decision ZHTW',
        DELETE_APPROVED_COMMERCIAL_DECISION: 'Deleted approved commercial decision ZHTW',
        CHOOSE_RELEASE_METHOD: 'Chose release method ZHTW',
      },
      TechnicalWarranty: {
        ACCEPTED: '公認',
        DENIED: '被拒絕',
        AGREE: '同意',
        DISAGREE: '不同意',
        MANUFACTURING: '製造業',
        DESIGN: '設計',
        VENDOR: '供應商',
        PROCESS: '處理',
        INHOUSE_REPAIR: '內部維修',
        FIELD_SERVICE_REPAIR: '現場服務維修',
        NO_FAULT_FOUND: '沒發現故障',
        WARRANTY_EXPIRED: '保修到期',
        WARRANTY_EXPIRED_NO_FAULT_FOUND: 'Out of standard warranty period - No fault found',
        WARRANTY_EXPIRED_CUSTOMER_FAULT: 'Out of standard warranty period - Customer fault',
        WARRANTY_EXPIRED_OTHER: 'Out of standard warranty period - Other',
        WARRANTY_EXPIRED_COMPONENT_ISSUE: 'Out of standard warranty period - Component issue (Edwards fault)',
        CUSTOMER_FAULT: '客戶過錯',
        OTHER: '其他',
        AGREE_WITH_TECHNICAL_WARRANTY_LOG: '同意技術決定', 
        DISAGREE_WITH_TECHNICAL_WARRANTY_LOG: '不同意技術決定',
        SPARE_PART: 'Spare part (Service Division) ZHTW',
      },
      CommercialWarranty: {
        CONTRACTUAL_AGREEMENT: '合同協議',
        GOODWILL_ACCEPTED: '接受商譽',
        CHARGEABLE_TO_CUSTOMER: '向客戶收費',
        EXTENDED_WARRANTY: '延長保修',
        SERVICE_CONTRACT: '服務合同', 
        OTHER: '其他',
        SEMICONDUCTOR: '半導體',
        SCIENTIFIC: '科學的',
        INDUSTRIAL: '產業',
        SEMICONDUCTOR_SERVICE: '半導體服務',
        VACUUM_TECHNIQUE_SERVICE: '真空技術服務',
        SEMICONDUCTOR_CHAMBER_SOLUTIONS: '半導體腔室解決方案',
        SEMI_ABATEMENT_AND_INTEGRATED_SYSTEMS: 'Semi Abatement & integrated systems',
        SEMI_ADVANCED_CHEMICAL_MANAGEMENT: 'Semi Advanced Chemical Management',
        SERVICE_CRYOGENICS: 'Service Cryogenics',
        SEMI_DRY_PUMPS: 'Semi Dry Pumps',
        INDUSTRIAL_CUSTOM_DESIGN: 'Industrial custom design',
        INDUSTRIAL_VACUUM: 'Industrial Vacuum',
        SCIENTIFIC_CUSTOM_DESIGN: 'Scientific custom design',
        SEMICON_TURBO_PUMPS: 'Semicon Turbo pumps',
        POLYCOLD: 'Polycold',
      },
      Release: {
        NO_TECHNICAL_TEAM_INVOLVEMENT: '沒有技術團隊的參與',
        GOLDENEYE_UPLINK: 'GoldenEye上行鏈路',
        ON_SITE_PRESENCE: '現場存在',
        RETURN_TO_PRODUCT_COMPANY: '返回產品公司',
        SEND_BACK_PARTS: '發回零件',
      },
      Forms: {
        fields: {
          basicInformation: '基本信息',
          customerCenter: '客戶中心',
          serviceTechnologyCenter: '服務技術中心',
          reportLevel: '報告等級',
          initialWarrantyCode: '初始保修',
          technicalDecision: '技術決定',
          commercialDecision: '商業決策',
          price: '價錢',
          jobStatus: '工作現狀',
          reportCompletion: '報告完成',
          alerts: '警報',
          team: '團隊',
          customer: '顧客',
          customerContact: '客戶聯繫',
          jobDetails: '工作細節',
          jobType: '工作類型',
          serviceProduct: '服務產品',
          equipment: '設備',
          failure: '失敗',
          symptom: '症狀',
          address: '地址',
          contactPerson: '聯繫人',
          email: '電子郵件',
          phone: '電話',
          customerPurchaseOrderNumber: '客戶採購訂單號',
          equipmentWarranty: '設備保修',
          serviceWarranty: '服務質保',
          reportStatus: '報告狀態',
          reopen: '重新開啟',
          releaseJob: '發布工作',
          notifyTeam: 'Notify team ZHTW',
        },
        errors: {
          required: '必填項',
          tel: '請輸入一個有效的電話號碼',
          email: '請輸入有效電子郵件',
          number: '只允許數字',
          alphanumeric: '不允許使用特殊字符',
          text: '請輸入一個有效的值',
          unknown: '出問題了',
          belowZero: '值不能小於 0.',
          uploadFailed: '上載失敗',
          maxFileSize: '允許的最大大小為',
          maxLength: maxLength => `Max ${maxLength} characters allowed`, // MISSING
          minLength: minLength => `Please enter at least ${minLength} characters`, // MISSING
        },
      },
      FaultCodes: {
        fallbackDescription: '沒有此代碼的描述',
        jobTypeDescription: {
          'JT001': 'JT作業類型的說明 JT001',
          'JT002': 'JT作業類型的說明 JT002',
        },
        faultCodeDescription: {
          'FC001': '故障代碼FC的說明 FC001',
          'FC002': '故障代碼FC的說明',
        },
        symptomCodeDescription: {
          'SC001': '症狀代碼SC的說明 SC001',
          'SC002': '症狀代碼SC的說明 FC002',
        },
      },
      Progress: {
        title: '進展',
        productReceived: '產品收到',
        productEvaluation: '產品評估',
        stripObservation: '拆解觀察',
        technicalInvestigation: '技術調查',
        conformityTest: '符合性測試',
      },
    },
    Profile: {
      title: '輪廓',
      name: '名稱',
      role: '角色',
      company: '公司',
      rights: '權利',
      linked: '用戶已鏈接到',
    },
    Jobs: {
      title: '職位',
      filters: '篩選器',
      myJobs: '我的工作',
      otherJobs: '其他工作',
      noJobsToDisplay: '沒有要顯示的工作',
      pleaseUseTheSearchBar: "Please use the search bar. ZHTW",
      id: 'ID',
      createdAt: '創建於',
      status: '狀態',
      customer: '顧客',
      serialProductNumber: '老師 產品編號',
      materialNumber: '材料號',
      equipmentSerialNumber: '設備s。 r',
      customerCenterPlantCode: '抄送 工廠代碼',
      serviceTechnologyCenterPlannerGroup: 'S.t.c. 策劃組',
      handledBy: '處理者',
      reportLevel: '報告等級',
      materialDescription: '材質說明',
      customerName: '顧客姓名',
      receivedDate: '收到的日期',
      customerCenterName: '抄送名稱',
      serviceOrderNumber: '服務訂單號',
      workFlow: '工作流程',
      analysisFlow: '分析流程',
      productReceived: '產品收到',
      productEvaluation: '產品評估',
      stripObservation: '帶狀觀察',
      technicalInvestigation: '技術調查',
      conformityTest: '符合性測試',
      notificationNumber: '通知號',
    },
    Job: {
      editButton: '編輯',
      progress: '進展',
    },
    Filters: {
      filtersTitle: '篩選器',
      applyButton: '應用',
      clearButton: '明確',
      sorting: '排序',
      sortNew: '排序最新',
      sortOld: '排序最舊',
      date: '日期',
      dateFrom: '從',
      dateTo: '至',
      reportLevel: '報告等級',
      status: '狀態',
      customerNumber: '顧客號碼',
      customerName: '顧客姓名',
      serviceProductNumber: '服務產品編號',
      materialNumber: '物料編號',
      equipmentSerialNumber: '設備序列號',
      stcPlannerGroup: 'STC規劃師小組',
      selectstcPlannerGroup: '選擇STC計劃者組',
      CCplant: 'CC工廠',
      selectCCplant: '選擇CC工廠',
      distributor: '發行人',
      selectDistributor: '選擇分銷商',
      failureAnalysisEngineerNotAssigned: '未分配給故障分析工程師',
      openedJobs: '職位空缺',
      publishedJobs: '已發布的職位',
      unreadMessages: '未讀郵件',
      pendingMyApproval: '等待我的批准',
      notificationNumber: '通知號',
      serviceOrderNumber: '服務訂單號',
    },
    AddJob: {
      formSections: {
        title: '新增工作',
        createdAt: '創立日期',
        button: '救',
        basicInformation: {
          title: '基本信息',
          fieldLabels: {
            equipmentSerialNumber: '設備序列號',
            serviceTechnologyCenter: '服務技術中心',
            customerCenter: '客戶中心',
            reportLevel: '報告等級',
            initialWarrantyCode: '初始保修',
            customerPurchaseOrderNumber: '客戶採購訂單號',
            responsibleSalesPerson: '負責銷售人員',
            customerCenterContactName: '客戶中心聯繫人姓名',
            customerCenterContactEmail: '客戶中心聯繫電子郵件',
          },
        },
        jobType: {
          title: '類型',
          fieldLabels: {
            jobType: '類型',
            jobTypeDescription: '描述',
          },
        },
        searchMaterialNumber: '搜索物料編號',
        materialNumber: {
          title: '物料編號',
          fieldLabels: {
            materialNumber: '物料編號',
            materialNumberDescription: '描述',
          },
        },
        serviceProductNumber: {
          title: '服務產品編號',
          fieldLabels: {
            serviceProductNumber: '服務產品編號',
            serviceProductNumberDescription: '描述',
          },
        },
        symptomCode: {
          title: '症狀代碼',
          fieldLabels: {
            scGroups: '症狀代碼組',
            symptomCode: '症狀代碼',
            symptomCodeDescription: '描述',
          },
        },
        faultCode: {
          title: '故障碼',
          fieldLabels: {
            fcGroups: '故障代碼組',
            faultCode: '故障碼',
            faultCodeDescription: '描述',
          },
        },
        customerInformation: {
          title: '客戶信息',
          fieldLabels: {
            customerId: '客戶ID',
            customerName: '名稱',
            customerAddress: '地址',
            customerContact: '聯繫人',
            customerEmail: '電子郵件地址',
            customerPhone: '電話號碼',
          },
        },
      },
    },
    ImportJob: {
      title: '匯入工作',
      date: '進口日期',
      importButton: '進口',
      searchTitle: '搜索要導入的工作',
      searchSubtitle: '至少5個字符，沒有前導零',
      searchButton: '搜索',
      notificationNumberLabel: '通知號',
      serviceOrderNumberLabel: '服務訂單號',
      linkTo: '鏈接到',
      openJobsFoundForSerNumber: '找到該序列號的空缺職位',
      importJobAsNew: '匯入新工作',
      jobIsImportedAlready: '作業已導入',
      importing: 'Importing in progress... ZHTW',
      linking: 'Linking in progress... ZHTW',
      columns: {
        sourceId: '來源編號',
        notificationNumber: '通知編號',
        serviceOrderNumber: '服務訂單號',
        serialNumber: '序列號',
        jobTypeDescription: '描述',
        customerName: '顧客姓名',
      },
    },
    SingleJob: {
      title: '工作',
      createdAt: '創建於',
      modifiedAt: '最後修改時間：',
      serviceOrderNumber: '服務訂單號',
      notificationNumber: '通知號',
      receivedProduct: '收到產品',
      productEvaluation: '產品評估',
      stripObservation: '帶狀觀察',
      technicalInvestigation: '技術調查',
      conformityTest: '符合性測試',
      log: '日誌記錄',
      conversation: '會話',
      noTechPossibilityParagraph1: '該STC沒有這項工作的測試能力',
      noTechPossibilityParagraph2: '請關閉工作並將泵發送到另一個STC',
      downloadPictures: '下載圖片',
      downloadAllPictures: '下載所有圖片',
      downloadPicturesFrom: '從下載圖片',
      downloadInProgressPleaseWait: 'Download in progress... Please wait ZHTW',
    },
    JobSummary: {
      title: '工作總結',
      createdAt: '創建於',
      modifiedAt: '最後修改時間：',
      reportLevelDialogTitle: '報告等級',
      reportLevelDialogContent: '設置請求的報告級別',
      reportLevelDialogInitialWarrantyCodeLabel: '初始保修',
      approveReportLevelDialogTitle: '批准報告級別的請求',
      technicalWarrantyDialogTitle: '提出技術決定',
      editTechnicalWarrantyDialogTitle: 'Edit technical decision proposal ZHTW',
      rateTechnicalDecisionTitle: '評價技術決策',
      rate: '率',
      reclassify: 'Reclassify ZHTW',
      technicalWarrantyDialogContent: '保固決定',
      technicalWarrantyDialogCategory: '保修類別',
      technicalWarrantyDialogSIBFieldLabel: '西伯利亞銀行',
      approveTechnicalWarrantyDialogTitle: '批准技術保修建議',
      approveTechnicalWarrantyDialogSIBLabel: '西伯利亞銀行',
      reclassifyTechnicalWarrantyDialogTitle: '重新分類技術決策類別',
      commercialDecisionDialogTitle: '提出商業決定',
      commercialDecisionDialogContent: '保固決定',
      commercialDecisionDialogCategory: '保修類別',
      approveCommercialDecisionDialogTitle: '批准提案',
      amendTechnicalWarrantyDecisionDialogTitle: 'Amend technical warranty decision ZHTW',
      amendCommercialDecisionDialogTitle: 'Amend commercial decision ZHTW',
      editPriceDialogTitle: '修改價格',
      editPriceLabel: '編輯',
      proposedDate: '擬定日期',
      releaseJobDialogTitle: '發布工作',
      chooseReleaseJobMethodTitle: '選擇下達工作方法',
      editChosenReleaseJobMethodTitle: '編輯選擇的發布作業方法',
      releaseJobDialogLabel: '選擇方式',
      reportStatusDialogTitle: '提出報告狀態',
      reportStatusDialogContent: '這將要求報告批准',
      approveReportStatusDialogContent: '您確定要重新開始這項工作嗎',
      approveReportStatusDialogTitle: '報告狀態',
      editJobStatusDialogTitle: '編輯工作狀態',
      editEquipmentSerialNumberDialogTitle: '編輯設備序列號',
      editEquipmentSerialNumberDialogFieldLabel: '設備序列號',
      editMaterialNumberDialogTitle: '編輯物料編號',
      editMaterialNumberDialogFieldLabel: '物料編號',
      editMaterialNumberDialogDescriptionFieldLabel: '描述',
      warrantyStartDialogTitle: '修改保修開始日期',
      warrantyStartDateLabel: '保修開始日期',
      warrantyEndDialogTitle: '修改保修結束日期',
      warrantyEndDateLabel: '保修截止日期',
      verifyJobDialogTitle: '驗證工作',
      verifyJobDialogContent: '此操作將鎖定材料和設備編號以進行編輯。 您確定以下數據正確嗎？',
      materialNumber: '物料編號',
      equipmentSerialNumber: '設備序列號',
      deleteConfirmationDialogTitle: '需要確認',
      deleteConfirmationDialogContent: '您確定要刪除此作業嗎',
      teamDialogTitle: '添加團隊成員',
      removeTeamMemberDialogTitle: '刪除團隊成員',
      removeTeamMemberDialogContent: '您確定要從團隊中刪除此成員嗎？',
      technicalDecisionReason: '技術決策原因',
      warrantyExpiredSubcategoryLabel: 'Out of standard warranty period - Warranty subcategory',
      changeReportLevelReason: '更改報告級別的原因',
      rateTechnicalDecisionComment: '對技術決策評級的評論',
      decisionReason: '決定原因',
      commercialDecisionReason: '商業決策原因',
      approveReportLevelDialogRequestedLevel: '要求等級',
      approveReportLevelDialogPreviousLevel: '上一級',
      approveReportLevelDialogInitialWarrantyCode: '初始保修',
      initialWarrantyCode: '初始保修',
      shipToAddress: '郵寄到地址',
      partNumbers: '零件號',
      failureReason: '失敗原因',
      symptomReason: '症狀原因',
      chooseMethod: '選擇方法',
      chosenMethod: '選擇方法',
      serialNumberMissingPleaseAdd: 'Serial number missing, please add. ZHTW',
      deleteImportedJob: 'Delete imported ZHTW',
      deleteImportedJobConfirmationDialogContent: 'Are you sure that you want to fully delete this imported job? ZHTW',
    },
    LogSection: {
      title: '日誌記錄',
      sib: '西伯利亞銀行',
      initialWarrantyCode: '初始保修',
    },
    ReportsDialog: {
      title: '產生報告',
      confirmButton: '生成',
      reportFormat: '報告格式',
      reportTemplate: '報告模板',
    },
    ActionMode: {
      takePicture: '拍照',
      takeStandardPicture: '拍攝標準照片',
      takeNonStandardPicture: '拍攝非標圖片',
      lastScreenMessage: '您已經到了本節的結尾。 請關閉此窗口',
      lastScreenMessageUnsavedAnswers: '您已经到了本节的结尾。 请保存'
    },
    InputFile: {
      special: '特別',
      upload: '上載',
      uploadStandardPicture: '上傳標準圖片',
      uploadNonStandardPicture: '上載非標準圖片',
      commentPicture: '評論圖片',
      confirmButtonText: '保存評論',
      moveFileModal: {
        title: '移動檔案',
        confirmButtonText: '移動',
        selectSubsection: '選擇小節',
        selectQuestion: '選擇問題',
      },
    },
    FilePreviewModal: {
      moveFileButtonText: '移動',
    },
  }
  


// WEBPACK FOOTER //
// ./src/constants/translations/zhtw.js